import { forwardRef } from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";
import { VbSelect } from "../VbSelect";
import { Input } from "../Input";
import { VbCheckBox } from "../VbCheckBox";
import { WeekInput } from "../WeekInput";
import FotoUploader from "../FotoUploader";

export const VbFormLabel = styled(Form.Label)`
    margin-left: .375rem;
    margin-bottom: .275rem;  
    font-size: .785rem;
    font-weight: bold;
`

export const VbFormFeedback = styled(Form.Control.Feedback)`
    margin: 0;
    font-size: .785rem;
    font-weight: 500;
`
interface VbControlsProps {
    id: any;
    name: any;
    type: any;
    label?: String;
    placeholder?: any;
    defaultValue?: any;
    feedback?: String;
    textfixed?: String;
    required?: any;
    md?: String;
    size?: any;
    onAfterChange?: any;
    search?: any;
    disabled?: any;
    options?: any;
    model?: any;
    validated?: any;
    maxLength?: any;
    textarea?: any;
    rows?: any;
    params_required?: any;
    defaultEmpId?: any;
    isMulti?: any;
}

export const VbControls = forwardRef((props: VbControlsProps, ref: any) => {
    const { options, ...input } = props;

    return (
        <>
            {
                props.type === 'select' ?
                    <VbSelect
                        id={props.id}
                        ref={ref}
                        label={props.label}
                        options={props.options}
                        defaultValue={props.defaultValue}
                        md={props.md}
                        required={props.required}
                        disabled={props.disabled}
                        model={props.model}
                        size={props.size}
                        validated={props.validated}
                        onAfterChange={props.onAfterChange}
                        params_required={props.params_required}
                        defaultEmpId={props.defaultEmpId}
                        isMulti={props.isMulti}
                    /> :
                    props.type === 'check' ?
                        <VbCheckBox
                            ref={ref}
                            id={props.id}
                            label={props.label}
                            defaultValue={props.defaultValue}
                            md={props.md}
                            size={props.size}
                        /> :
                        props.type === 'week' ?
                            <WeekInput
                                ref={ref}
                                id={props.id}
                                label={props.label}
                                md={props.md}
                                required={props.required}
                                size={props.size}
                                defaultValue={props.defaultValue}
                            /> : props.type === 'photo' ?
                                <FotoUploader
                                    ref={ref}
                                    id={props.id}
                                    md={props.md}
                                    size={props.size}
                                    defaultValue={props.defaultValue}
                                />
                                : <Input ref={ref} {...input} />
            }
        </>
    )
})